import { render, staticRenderFns } from "./ScanViewer.vue?vue&type=template&id=2fcba560&"
import script from "./ScanViewer.vue?vue&type=script&lang=js&"
export * from "./ScanViewer.vue?vue&type=script&lang=js&"
import style0 from "./ScanViewer.vue?vue&type=style&index=0&id=2fcba560&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports